import { mapActions, mapState } from 'vuex';
import Wishlist from '@phoenix/mixins/components/myAccount/Wishlist';

export default {
  mixins: [Wishlist],

  data() {
    return {
      loadOnCreate: false,
      isShownAndLoaded: false,
    };
  },

  computed: {
    ...mapState('myAccount', ['menuLinks']),

    ...mapState('currentUser', ['isLogged']),

    panelOptions() {
      return {
        onShow: async () => {
          if (!this.areProductsLoaded) {
            await this.loadWishlistProducts();
            await this.loadCustomerInfo();
            this.isShownAndLoaded = true;
          }
        },
      };
    },
  },

  methods: {
    ...mapActions('currentUser', ['loadCustomerInfo']),
  },
};
